import React from 'react';
import { FlowsQuestion } from '@flows/src/types/FlowsTypes';
import RadioYesNoSmallInputComponent from './RadioYesNoSmallInputComponent';

interface Props {
  question: FlowsQuestion;
}

const RadioSmallInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  return <RadioYesNoSmallInputComponent question={question} />;
};

export default RadioSmallInputPicker;
